import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import ProtectedRoute from "@/auth/ProtectedRoute";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import HowItWorks from "@/components/site/HowItWorks";
import Benefits from "@/components/site/Benefits";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Waitlist from "@/components/site/Waitlist";
import Footer from "@/components/site/Footer";
import PartnerTeaser from "@/components/site/PartnerTeaser";

import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import EventDetail from "@/pages/EventDetail";
import GuestWedding from "@/pages/GuestWedding";
import AuthCallback from "@/auth/AuthCallback";
import Privacy from "@/pages/Privacy";
import LiveSlideshow from "@/pages/LiveSlideshow";
import PublicGallery from "@/pages/PublicGallery";
import PartnerPage from "@/pages/PartnerPage";
import AdminPartner from "@/pages/AdminPartner";

const Landing = () => {
  const { supabaseUser, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && supabaseUser) navigate("/dashboard", { replace: true });
  }, [supabaseUser, loading, navigate]);

  return (
    <div className="App" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Benefits />
        <Pricing />
        <Testimonials />
        <FAQ />
        <PartnerTeaser />
        <Waitlist />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <I18nProvider defaultLocale="it">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard/:weddingId"
              element={
                <ProtectedRoute>
                  <EventDetail />
                </ProtectedRoute>
              }
            />
            <Route path="/wedding/:slug" element={<GuestWedding />} />
            <Route path="/live/:slug" element={<LiveSlideshow />} />
            <Route path="/gallery/:slug" element={<PublicGallery />} />
            <Route path="/partner" element={<PartnerPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/partner" element={<AdminPartner />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
